/* ImageUploadComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ImageUploadRenderer");

class ImageUploadComponent extends EventEmitter {
    constructor({callback, image, defaultImg, MUF, configOptions, noImageText, description, title, editOpts, deleteOpts}) {
        super();
        // this._context = context;
        this._existingImage = image;
        this._defaultImage = defaultImg;
        this.callback = callback;
        this._muf = MUF;
        this._noImageText = noImageText;
        this._description = description;
        this._title = title;
        this._editorConfig = configOptions;
        this._editOpts = editOpts;
        this._deleteOpts = deleteOpts; 
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/

    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }

    get stringValue() {
        return this.getStringValue();
    }

    getStringValue() {
        return this._noImageText;
    }
    set stringValue(str) {
        this.setStringValue(str);
    }

    setStringValue(str) {
        this._noImageText = str;
    }
    
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._existingImage = undefined;
        this.callback = undefined;
        this._muf = undefined;
        this._noImageText = undefined;
        this._editorConfig = undefined;
        this._editOpts = undefined;
        this._deleteOpts = undefined; 
        return prom;
    }
    
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=ImageUploadComponent;
